export default __webpack_public_path__ + "static/media/grafema_clivitalbio_14.e997198f.jpg";